<template>
    <div class="ldc-dropdown-menu">
        <div class="ldc-dropdown-content" :style="`height: ${height}px`">
            <div class="ldc-dropdown-slot">
                <slot/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            height: 0,
            show: false,
        }
    },
    watch: {
        show(val){
            if(val){
                this.showMenu();
            }else{
                this.hideMenu();
            }
            this.$parent.active = val;
        }
    },
    methods: {
        showMenu(){
            if(this.$el){
                let slot = this.$el.querySelector('.ldc-dropdown-slot');
                if(slot){
                    this.height = slot.clientHeight + 5;
                }
            }
        },
        hideMenu(){
            this.height = 0;
        }
    }
}
</script>